import { useState } from 'react';
import { AlertaProps } from '@/types';

// 🔹 Estructura de una opción del select
interface Option {
  value: string | number;
  label: string;
}

// 🔹 Props que acepta el componente Select
interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options?: Option[];      // Lista de opciones dinámicas
  placeholder?: string;    // Texto mostrado cuando no hay valor
  disabled?: boolean;      // Estado deshabilitado
  readOnly?: boolean;      // Estado de solo lectura
  error?: string | boolean | AlertaProps;
}

// 🔹 Componente principal Select
export function Select({
  className,
  disabled = false,
  options = [],
  placeholder,
  value,
  readOnly = false,
  error,
  ...props
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  // Animar flecha al enfocar y perder foco
  const handleFocus = () => setIsOpen(true);
  const handleBlur = () => setIsOpen(false);

  return (
    <div className="relative">
      <select
        className={`
          w-full px-3 py-1 rounded-md
          border ${error || value === "" ? "bg-blue-100" : "border-zinc-600 dark:bg-blue-100"}        
          text-zinc-700
          cursor-text
          shadow-[inset_-2px_-2px_1px_rgb(99,105,112)]
          focus:shadow-[inset_2px_3px_2px_rgb(24,25,27)]
          outline-none
          appearance-none
          transition-all duration-200
          ${className}
        `}
        value={value !== undefined && value !== null ? value.toString() : ""}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled || readOnly}
        {...props}
      >
        {/* Placeholder */}
        {placeholder && (
          <option value="" disabled hidden>
            {placeholder}
          </option>
        )}

        {/* Opciones */}
        {options.map((option) => (
          <option key={option.value.toString()} value={option.value.toString()}>
            {option.label}
          </option>
        ))}
      </select>

      {/* Flecha personalizada */}
      <div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
        <svg
          className={`h-5 w-5 text-zinc-600 transform transition-transform duration-200 ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="18 15 12 9 6 15" />
        </svg>
      </div>
    </div>
  );
}

export default Select;
